module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "user-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pull-left info"
  }, [_c('div', [_c('p', {
    staticClass: "white username"
  }, [_vm._v(_vm._s(_vm.displayName))])]), _vm._v(" "), (this.$store.state.online) ? _c('a', {
    attrs: {
      "href": "javascript:;",
      "id": "status"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle text-success"
  }), _vm._v(" Online\n        ")]) : _vm._e(), _vm._v(" "), (!this.$store.state.online) ? _c('a', {
    attrs: {
      "href": "javascript:;",
      "id": "status"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle text-danger"
  }), _vm._v(" Offline\n        ")]) : _vm._e()])]), _vm._v(" "), _c('sidebar-menu')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left image"
  }, [_c('i', {
    staticClass: "fas fa-user"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a51a6df0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 1038
// module chunks = 1